import { IEventItem, IEventsStore } from '../store';

import api, { request } from '../../../../api';
import { IStore } from '../../../index';
import { IEventsActionResponse } from '../Utils/TEventsActionResponse';

export const getAllFutureClubEvents = async (
  state: IStore,
  clubId: string,
  force?: boolean
): Promise<IEventsActionResponse> => {
  if (Object.keys(state.events.all).length && !force) {
    return { events: state.events };
  }

  const response = await request.get(`${api.futureClubEvents(clubId)}`);

  if (response.error) {
    return { errors: { events: { msg: 'Error retrieving the Event List.' } } };
  }

  const allEvents = response.reduce(
    (parsedEvents: IEventsStore, rawEvent: IEventItem) => ({
      ...parsedEvents,
      [rawEvent.id]: rawEvent
    }),
    {}
  );

  return {
    events: {
      ...state.events,
      all: allEvents
    }
  };
};
